// -----------------------------------------------------------------------
// <copyright file="InitParameters.tsx" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

import { M365ThemeKind } from '@ms/centro-hvc-loader';
import { appContext } from '../../models/getHelp/appContext';
import { GetHelpBaseUrl } from '../../models/getHelp/environmentConfig';

import {
  FeedbackAgeGroup,
  FeedbackAuthenticationType,
  FeedbackPolicyValue,
  FeedbackUiType,
  IFeedbackInitOptions,
} from './FeedbackTypes';

function logOnDismiss() {
  // TODO: Brook
  // logOCVFeedbackDismissed();
}

function logOnError(_errorMessage?: string) {
  // TODO: Brook
  // logOCVFeedbackSendError(errorMessage);
}

function logOnSuccess() {
  // TODO: Brook
  // logOCVFeedbackSendSuccess();
}

export const InitialFeedbackData: IFeedbackInitOptions = {
  // Different appId will direct feedback to different OCV environment
  // OCV PROD appId has 4 digits and OCV PPE appId has 5 digits
  // Feedback sent to PROD will also show up in PPE env
  appId: appContext.environment.baseUrl === GetHelpBaseUrl.Prod ? 2721 : 50171,
  isProduction: true,
  clientName: 'GetHelpApp',
  authenticationType: FeedbackAuthenticationType.Unauthenticated,
  ageGroup: FeedbackAgeGroup.Undefined,
  callbackFunctions: {
    onDismiss: logOnDismiss,
    onSuccess: logOnSuccess,
    onError: logOnError,
  },

  feedbackConfig: {
    appData: '',
    email: '',
    featureAreas: [],
    // URL for feature Feedback Forum
    feedbackForumUrl: '',
    feedbackUiType: FeedbackUiType.Modal,
    isDisplayed: false,
    isEmailCollectionEnabled: true,
    isFeedbackForumEnabled: false,
    isMyFeedbackEnabled: false,
    isScreenshotEnabled: false,
    isScreenRecordingEnabled: false,
    isFileUploadEnabled: false,
    maxWidth: 397,
    // URL for feature My Feedback
    myFeedbackUrl: '',
    privacyUrl: 'https://go.microsoft.com/fwlink/?LinkId=521839',
    retentionDurationDays: null,
    complianceChecks: {
      connectedExperiences: FeedbackPolicyValue.Enabled,
      policyAllowFeedback: FeedbackPolicyValue.Enabled,
      policyAllowSurvey: FeedbackPolicyValue.Enabled,
      policyAllowScreenshot: FeedbackPolicyValue.Enabled,
      policyAllowContact: FeedbackPolicyValue.Enabled,
      policyAllowContent: FeedbackPolicyValue.Enabled,
    },
  },

  userId: '',
  tenantId: '9188040d-6c67-4c5b-b112-36a304b66dad',
  themeOptions: { baseTheme: M365ThemeKind.FabricDefaultTheme },
};
